import { useAuthDetails } from "@/context/auth-context";
import { useGroupSlug } from "@/hooks/use-group-slug";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { kitLabel } from "@/lib/kit-label";
import { Kit } from "@/types/types";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { KitDeletionDialog } from "./dependency-deletion/KitDeletionDialog";
import { Button } from "./ui/button";

type KitDeletionAreaProps = {
  kit: Kit;
};

export const KitDeletionArea: React.FC<KitDeletionAreaProps> = ({ kit }) => {
  const groupSlug = useGroupSlug();
  const groupUuid = useGroupUuid();
  const authDetails = useAuthDetails();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const canDelete =
    kit.type !== "project" ||
    (kit.user_uuid === authDetails?.uuid && kit.group_uuid === groupUuid);

  if (!canDelete || !groupUuid) {
    return null;
  }

  return (
    <>
      <div className="border-destructive text-destructive my-8 flex flex-col gap-4 rounded-md border-1 p-4">
        <div className="text-lg font-bold">Danger Zone</div>
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-col gap-2">
            <div>This will delete {kit.name} permanently.</div>
            <div>This {kitLabel(kit)} cannot be recovered.</div>
          </div>
          <Button variant="destructive" onClick={() => setOpen(true)}>
            Delete
          </Button>
        </div>
      </div>

      <KitDeletionDialog
        kitUuid={kit.uuid}
        groupUuid={groupUuid}
        open={open}
        onOpenChange={setOpen}
        onDelete={() => {
          navigate({ to: "/w/$groupSlug", params: { groupSlug } });
        }}
      />
    </>
  );
};
